<template>
  <v-container grid-list-md>
    <v-card class="px-2 pt-3 pb-1">
      <h4>Home In Love</h4>
      <h5>Partner</h5>
      <p class="mt-2">
        Cette application est réservée aux partenaires de la société Home In
        Love.
      </p>
    </v-card>
    <v-card class="px-2 pt-3 pb-3 mt-3">
      <a :href="`${rootUrl}/cgu/`">Politique de confidentialité</a>
    </v-card>
  </v-container>
</template>

<script>
import { ROOT_URL } from "../../../webapp-commons/config";

export default {
  name: "About",
  data() {
    return {
      rootUrl: ROOT_URL,
    };
  },
};
</script>

<style scoped></style>
